export type RecipeDraftCategoryValue = {
  productCategory?: string | null;
  categoryId?: string | null;
  categoryName?: string | null;
};

export type RecipeDraftCategoryOption = {
  id?: string;
  name?: string;
  nameEn?: string | null;
};

/**
 * One matcher for paginated queue reads and cross-page selection. Catalog
 * records normally store the category id, while legacy products can retain
 * either localized category name.
 */
export function matchesRecipeDraftCategory(
  row: RecipeDraftCategoryValue,
  selectedCategory: string | undefined,
  categories: RecipeDraftCategoryOption[],
) {
  if (!selectedCategory) return true;
  const normalize = (value: unknown) => String(value || "").trim().toLocaleLowerCase();
  const selected = normalize(selectedCategory);
  const category = categories.find((candidate) =>
    [candidate.id, candidate.name, candidate.nameEn].some((value) => normalize(value) === selected));
  const accepted = new Set([selected, category?.id, category?.name, category?.nameEn].map(normalize).filter(Boolean));
  return [row.productCategory, row.categoryId, row.categoryName].some((value) => accepted.has(normalize(value)));
}